import { useState } from 'react';
import { MIN_OUTPUT_SIZE } from './constants';

export function useZoomControl() {
  const [scale, setScale] = useState(1);
  const [maxScale, setMaxScale] = useState(1);

  const updateMaxScale = (imageWidth: number, imageHeight: number) => {
    const minDimension = Math.min(imageWidth, imageHeight);
    setMaxScale(minDimension / (MIN_OUTPUT_SIZE + 1));
    setScale(1);
  };

  const reset = () => {
    setScale(1);
    setMaxScale(1);
  };

  return { scale, maxScale, setScale, updateMaxScale, reset };
}
